let csvw_url = 'https://www.csvw.com';
export default {
  // kv
  workspace: {
    videourl: csvw_url + "/u/cms/www/202103/25010628Gn7j.mp4"
  },
  // 车型素材
  workspace2: {
    neishi: [
      // require("../../assets/id/imgs/neishi/1.jpg"),
      require("../../assets/id/imgs/neishi/2.jpg"),
      require("../../assets/id/imgs/neishi/3.jpg"),
      require("../../assets/id/imgs/neishi/4.jpg"),
      require("../../assets/id/imgs/neishi/5.jpg"),
      require("../../assets/id/imgs/neishi/6.jpg"),
      require("../../assets/id/imgs/neishi/7.jpg"),
      require("../../assets/id/imgs/neishi/8.jpg"),
      require("../../assets/id/imgs/neishi/9.jpg"),
      require("../../assets/id/imgs/neishi/10.jpg"),
      require("../../assets/id/imgs/neishi/11.jpg"),
      require("../../assets/id/imgs/neishi/12.jpg"),
      require("../../assets/id/imgs/neishi/13.jpg"),
      require("../../assets/id/imgs/neishi/14.jpg"),
      require("../../assets/id/imgs/neishi/15.jpg"),
      require("../../assets/id/imgs/neishi/16.jpg"),
      require("../../assets/id/imgs/neishi/17.jpg"),
      require("../../assets/id/imgs/neishi/18.jpg"),
      require("../../assets/id/imgs/neishi/19.jpg"),
      require("../../assets/id/imgs/neishi/20.jpg"),
    ],
    waiguan: [
      // require("../../assets/id/imgs/waiguan/1.jpg"),
      // require("../../assets/id/imgs/waiguan/2.jpg"),
      // require("../../assets/id/imgs/waiguan/3.jpg"),
      require("../../assets/id/imgs/waiguan/4.jpg"),
      // require("../../assets/id/imgs/waiguan/5.jpg"),
      // require("../../assets/id/imgs/waiguan/6.jpg"),
      require("../../assets/id/imgs/waiguan/7.jpg"),
      require("../../assets/id/imgs/waiguan/8.jpg"),
      require("../../assets/id/imgs/waiguan/9.jpg"),
      require("../../assets/id/imgs/waiguan/10.jpg"),
      // require("../../assets/id/imgs/waiguan/11.jpg"),
      // require("../../assets/id/imgs/waiguan/12.jpg"),
      // require("../../assets/id/imgs/waiguan/13.jpg"),
      require("../../assets/id/imgs/waiguan/14.jpg"),
      // require("../../assets/id/imgs/waiguan/15.jpg"),
      require("../../assets/id/imgs/waiguan/16.jpg"),
      // require("../../assets/id/imgs/waiguan/17.jpg"),
      require("../../assets/id/imgs/waiguan/18.jpg"),
      require("../../assets/id/imgs/waiguan/19.jpg"),
      require("../../assets/id/imgs/waiguan/20.jpg"),
      require("../../assets/id/imgs/waiguan/21.jpg"),
    ],
    qita: [
      require("../../assets/id/imgs/qita/1.jpg"),
      require("../../assets/id/imgs/qita/2.jpg"),
      require("../../assets/id/imgs/qita/3.jpg"),
      require("../../assets/id/imgs/qita/4.jpg"),
      require("../../assets/id/imgs/qita/5.jpg"),
      require("../../assets/id/imgs/qita/6.jpg"),
      require("../../assets/id/imgs/qita/7.jpg"),
      require("../../assets/id/imgs/qita/8.jpg"),
      require("../../assets/id/imgs/qita/9.jpg"),
      require("../../assets/id/imgs/qita/10.jpg"),
    ],
    shipin: [
      require("../../assets/id/imgs/shipin/1.jpg"),
      require("../../assets/id/imgs/shipin/2.jpg"),
      require("../../assets/id/imgs/shipin/3.jpg"),
    ],
    videourl: [
      csvw_url + "/u/cms/www/202103/180956067F03.mp4",
      csvw_url + "/u/cms/www/202103/18095606855B.mp4",
      csvw_url + "/u/cms/www/202103/180956066CdF.mp4"
    ],
  },
  // 新闻稿
  workspace3: {
    list: [{
        title: '点亮你心中的光',
        title1: '上汽大众全新纯电SUV ID.4 X上市交付',
        subtitle: '3月25日，上汽大众在上海外滩国际电竞文化中心举办ID.4 X聚光派对，国内首款MEB平台纯电动车ID.4 X上市交付。活动现场，品牌代言人刘亦菲、Mandarin乐队亲临助阵。同时，大众品牌官宣ID.家族与宝可梦合作，皮卡丘应援发电，终极彩蛋揭开ID.4 X上市。当晚，上汽大众汽车有限公司总经理陈贤章向首批车主代表现场交付ID.4 X。',
        imgurl: require("../../assets/id/imgs/xinwen/1.jpg"),
        imgurlMobile: require("../../assets/id/imgsMobile/xinwen/1.jpg"),
        url: 'https://www.csvw.com/csvw-website/news/dz-brand-news.html?newsid=2986'
      },
      {
        title: '舒适党看过来',
        title1: '上汽大众ID.4 X人性化空间方案全知道',
        subtitle: '上汽大众ID.4 X的预售与路演正在进行时，很多有预定意向的消费者均已亲身体验到实车，对大众品牌全新的“光语律动”设计、以及ID.4 X的人性化车内布局留下深刻印象。ID.4 X基于MEB平台优势，同时注入“以人为本”的设计巧思，用大空间豪华享受满足国内汽车用户对舒适性的“挑剔”眼光。',
        imgurl: require("../../assets/id/imgs/xinwen/2.jpg"),
        imgurlMobile: require("../../assets/id/imgsMobile/xinwen/2.jpg"),
        url: 'https://www.csvw.com/csvw-website/news/dz-brand-news.html?newsid=2982'
      },
      {
        title: '德系实力传承',
        title1: '扒一扒上汽大众ID.4 X的品质故事',
        subtitle: '据悉，上汽大众ID.4 X即将在3月底进入交付阶段。1月底预售以来，ID.4 X关注度节节攀高，也说明大众品牌的造车实力深受信赖。作为一款致力于打造品质标杆的电动车，ID.4 X凭借上汽大众30多年累积的造车经验与诸多智能制造新技术的应用，为消费者带来实力传承的品质体验。',
        imgurl: require("../../assets/id/imgs/xinwen/3.jpg"),
        imgurlMobile: require("../../assets/id/imgsMobile/xinwen/3.jpg"),
        url: 'https://www.csvw.com/csvw-website/news/dz-brand-news.html?newsid=2977'
      }
    ]
  },
  // 大咖点评
  workspace4: {
    list: [{
        title: require("../../assets/id/imgs/logo/1.png"),
        titleMobile: require("../../assets/id/imgs/logo/1.png"),
        subtitle: 'ID.4 X前大灯的迎宾唤醒与离车休眠光效，贯穿式尾灯可自定义三种迎宾动画效果。',
        imgurl: require("../../assets/id/imgs/daka/1.jpg"),
        imgurlMobile: require("../../assets/id/imgsMobile/daka/1.jpg"),
        url: 'http://auto.sina.com.cn/review/tiyan/2021-03-23/detail-ikkntiam6918035.shtml'
      },
      {
        title: require("../../assets/id/imgs/logo/2.png"),
        titleMobile: require("../../assets/id/imgs/logo/2.png"),
        subtitle: 'ID.4 X液晶仪表盘虽然只有5.3英寸，中控液晶显示屏却达到了12英寸，并且是全系标配。界面的功能挺丰富操作却并不复杂，因为常用功能几乎都保留了实体按键。',
        imgurl: require("../../assets/id/imgs/daka/2.jpg"),
        imgurlMobile: require("../../assets/id/imgsMobile/daka/2.jpg"),
        url: 'https://www.pcauto.com.cn/pingce/2451/24515751.html?ad=12652'
      },
      {
        title: require("../../assets/id/imgs/logo/3.png"),
        titleMobile: require("../../assets/id/imgs/logo/3.png"),
        subtitle: 'ID.4 X全新简约风内饰搭配多变的内饰色彩非常洋气，除了造型设计以外，氛围灯也扩展出更多功能，车厢氛围相当到位。',
        imgurl: require("../../assets/id/imgs/daka/3.jpg"),
        imgurlMobile: require("../../assets/id/imgsMobile/daka/3.jpg"),
        url: 'http://auto.news18a.com/news/storys_153107.html'
      },
      {
        title: require("../../assets/id/imgs/logo/4.png"),
        titleMobile: require("../../assets/id/imgs/logo/4.png"),
        subtitle: 'ID.4 X提供19、20以及21英寸轮毂可选，按车型配置由低到高。',
        imgurl: require("../../assets/id/imgs/daka/4.jpg"),
        imgurlMobile: require("../../assets/id/imgsMobile/daka/4.jpg"),
        url: 'https://www.maiche.com/news/detail/2377135.html'
      },
      {
        title: require("../../assets/id/imgs/logo/5.png"),
        titleMobile: require("../../assets/id/imgs/logo/5.png"),
        subtitle: 'ID.4 X分为了四种驾驶模式，分别是经济、舒适、运动和个性化，运动模式可以带来更为迅猛的动力体验，动能回收拖拽感也更为强烈，转向虚位也更低。',
        imgurl: require("../../assets/id/imgs/daka/5.jpg"),
        imgurlMobile: require("../../assets/id/imgsMobile/daka/5.jpg"),
        url: 'https://www.dripcar.com/zixun/131757.html'
      },
      {
        title: require("../../assets/id/imgs/logo/6.png"),
        titleMobile: require("../../assets/id/imgs/logo/6.png"),
        subtitle: 'ID.4 X是通过4大条件来测算可行驶里程的。一是电池，包括电池的电量，电池的健康程度以及电池的温度；二是前50-70公里驾驶风格；三是高压电（暖风空调）的用电情况；四是低压电用电情况（音响手机充电等）。',
        imgurl: require("../../assets/id/imgs/daka/6.jpg"),
        imgurlMobile: require("../../assets/id/imgsMobile/daka/6.jpg"),
        url: 'http://www.niuche.com/news/detail_523892.html'
      },
      {
        title: require("../../assets/id/imgs/logo/7.png"),
        titleMobile: require("../../assets/id/imgs/logo/7.png"),
        subtitle: 'ID.4 X车身侧面线条流畅，采用了动感流线的曲面设计，上扬的腰线配合双色车身营造出强烈的时尚气息。',
        imgurl: require("../../assets/id/imgs/daka/7.jpg"),
        imgurlMobile: require("../../assets/id/imgsMobile/daka/7.jpg"),
        url: 'https://baijiahao.baidu.com/s?id=1694990905716877180&wfr=spider&for=pc'
      },
      {
        title: require("../../assets/id/imgs/logo/8.png"),
        titleMobile: require("../../assets/id/imgs/logo/8.png"),
        subtitle: 'ID.4 X的中控台主要由一大一小两块屏幕组成，显示效果都非常细腻，中控屏幕为12英寸，几乎集成了全车所有功能设置的操作，支持智能语音助手、高德地图、酷我音乐等便捷功能。',
        imgurl: require("../../assets/id/imgs/daka/8.jpg"),
        imgurlMobile: require("../../assets/id/imgsMobile/daka/8.jpg"),
        url: 'http://www.buyevcar.com.cn/news/4207.html'
      },
      {
        title: require("../../assets/id/imgs/logo/9.png"),
        titleMobile: require("../../assets/id/imgs/logo/9.png"),
        subtitle: 'ID.4 X配备的“AR-HUD增强现实抬头显示功能+ ID.Light光语系统”，除了可以显示时速，限速等基础信息之外，在转弯时可以直接将行驶路线投射到挡风玻璃上，ID.Light光语系统还辅有灯光提示。',
        imgurl: require("../../assets/id/imgs/daka/9.jpg"),
        imgurlMobile: require("../../assets/id/imgsMobile/daka/9.jpg"),
        url: 'https://baijiahao.baidu.com/s?id=1695107201590217733&wfr=spider&for=pc'
      },
      {
        title: require("../../assets/id/imgs/logo/10.png"),
        titleMobile: require("../../assets/id/imgs/logo/10.png"),
        subtitle: 'ID.4 X的后排，不像油改电车型那样出现高地台的情况，地台高度与传统燃油车并无二致，坐垫长度也完全足够，可以提供较好的支撑。',
        imgurl: require("../../assets/id/imgs/daka/10.jpg"),
        imgurlMobile: require("../../assets/id/imgsMobile/daka/10.jpg"),
        url: 'https://www.sohu.com/a/456928899_108024'
      },
      // {
      //   title: require("../../assets/id/imgs/logo/11.png"),
      //   titleMobile: require("../../assets/id/imgs/logo/11.png"),
      //   subtitle: 'ID.4 X全系都标配了道路交通标识识别、主动刹车/主动安全系统，并且除了入门的两款车型外，其余均配备了并线辅助、车道偏离预警和车道保持辅助系统。',
      //   imgurl: require("../../assets/id/imgs/daka/11.jpg"),
      //   imgurlMobile: require("../../assets/id/imgsMobile/daka/11.jpg"),
      //   url: 'http://www.yihaocar.com/evaluate_detail/detail/917898.html'
      // },
      {
        title: require("../../assets/id/imgs/logo/12.png"),
        titleMobile: require("../../assets/id/imgs/logo/12.png"),
        subtitle: 'ID.4 X的座舱被称为“数字化”座舱，全车除车窗按键和后视镜调节按钮外，其他的按键都采用触摸式，轻触会有声音和震动回馈，充满电子产品的数字感。',
        imgurl: require("../../assets/id/imgs/daka/12.jpg"),
        imgurlMobile: require("../../assets/id/imgsMobile/daka/12.jpg"),
        url: 'https://www.d1ev.com/carnews/shijia/142211'
      },
      {
        title: require("../../assets/id/imgs/logo/13.png"),
        titleMobile: require("../../assets/id/imgs/logo/13.png"),
        subtitle: 'ID.4 X前脸不像燃油车型那样严肃，上格栅采用封闭设计，一条动感的横向灯带贯穿两侧LED大灯。侧面腰线较高，不同的拼色饰条配合流线车顶，塑造出动感流线的曲面。',
        imgurl: require("../../assets/id/imgs/daka/13.jpg"),
        imgurlMobile: require("../../assets/id/imgsMobile/daka/13.jpg"),
        url: 'https://chejiahao.autohome.com.cn/info/8209033'
      },
    ]
  },
  // 媒体试驾
  workspace5: {
    // 移动端
    shipin: [
      require("../../assets/id/imgs/shijia/1.jpg"),
      require("../../assets/id/imgs/shijia/2.jpg"),
      require("../../assets/id/imgs/shijia/3.jpg"),
      require("../../assets/id/imgs/shijia/4.jpg"),
      require("../../assets/id/imgs/shijia/5.jpg"),
      require("../../assets/id/imgs/shijia/6.jpg"),
    ],
    // PC端
    shipinPC: [
      [
        require("../../assets/id/imgs/shijia/1.jpg"),
        require("../../assets/id/imgs/shijia/2.jpg"),
        require("../../assets/id/imgs/shijia/3.jpg"),
      ],
      [
        require("../../assets/id/imgs/shijia/4.jpg"),
        require("../../assets/id/imgs/shijia/5.jpg"),
        require("../../assets/id/imgs/shijia/6.jpg"),
      ]
    ],
    // 封面
    fengurl: [
      require("../../assets/id/imgs/shijia/1-1.jpg"),
      require("../../assets/id/imgs/shijia/2-1.jpg"),
      require("../../assets/id/imgs/shijia/3-1.jpg"),
      require("../../assets/id/imgs/shijia/4-1.jpg"),
      require("../../assets/id/imgs/shijia/5-1.jpg"),
      require("../../assets/id/imgs/shijia/6-1.jpg"),
    ],
    videourl: [
      csvw_url + "/u/cms/www/202103/262111010oQC.mp4",
      csvw_url + "/u/cms/www/202103/262109476U8S.mp4",
      csvw_url + "/u/cms/www/202103/2621112468L8.mp4",
      csvw_url + "/u/cms/www/202103/26211242aD76.mp4",
      csvw_url + "/u/cms/www/202103/26211251lA24.mp4",
      csvw_url + "/u/cms/www/202103/26211148wu36.mp4"
    ],
  },
  // 现场直击
  workspace6: {
    // 移动端
    shipin: [
      // require("../../assets/id/imgs/xianchang/1.jpg"),
      // require("../../assets/id/imgs/xianchang/2.jpg"),
      require("../../assets/id/imgs/xianchang/3.jpg"),
      require("../../assets/id/imgs/xianchang/4.jpg"),
      require("../../assets/id/imgs/xianchang/5.jpg"),
      require("../../assets/id/imgs/xianchang/6.jpg"),
      require("../../assets/id/imgs/xianchang/7.jpg"),
      require("../../assets/id/imgs/xianchang/8.jpg"),
      require("../../assets/id/imgs/xianchang/9.jpg"),
      require("../../assets/id/imgs/xianchang/10.jpg"),
      require("../../assets/id/imgs/xianchang/11.jpg"),
      require("../../assets/id/imgs/xianchang/12.jpg"),
      require("../../assets/id/imgs/xianchang/13.jpg"),
      require("../../assets/id/imgs/xianchang/14.jpg"),
      require("../../assets/id/imgs/xianchang/15.jpg"),
      require("../../assets/id/imgs/xianchang/16.jpg"),
      require("../../assets/id/imgs/xianchang/17.jpg"),
      require("../../assets/id/imgs/xianchang/18.jpg"),
      require("../../assets/id/imgs/xianchang/19.jpg"),
      require("../../assets/id/imgs/xianchang/20.jpg"),
      require("../../assets/id/imgs/xianchang/21.jpg"),
    ],
    // PC端
    shipinPC: [
      [
        require("../../assets/id/imgs/xianchang/4.jpg"),
        require("../../assets/id/imgs/xianchang/5.jpg"),
        require("../../assets/id/imgs/xianchang/6.jpg"),
      ],
      [
        require("../../assets/id/imgs/xianchang/7.jpg"),
        require("../../assets/id/imgs/xianchang/11.jpg"),
        require("../../assets/id/imgs/xianchang/12.jpg"),
        // require("../../assets/id/imgs/xianchang/8.jpg"),
        // require("../../assets/id/imgs/xianchang/9.jpg"),
      ],
      // [
        // require("../../assets/id/imgs/xianchang/10.jpg"),
        // require("../../assets/id/imgs/xianchang/11.jpg"),
        // require("../../assets/id/imgs/xianchang/12.jpg"),
      // ],
      [
        require("../../assets/id/imgs/xianchang/3.jpg"),
        require("../../assets/id/imgs/xianchang/13.jpg"),
        require("../../assets/id/imgs/xianchang/14.jpg"),
        // require("../../assets/id/imgs/xianchang/15.jpg"),
      ],
      // [
      //   require("../../assets/id/imgs/xianchang/16.jpg"),
      //   require("../../assets/id/imgs/xianchang/17.jpg"),
      //   require("../../assets/id/imgs/xianchang/18.jpg"),
      // ],
      // [
        // require("../../assets/id/imgs/xianchang/19.jpg"),
        // require("../../assets/id/imgs/xianchang/20.jpg"),
        // require("../../assets/id/imgs/xianchang/21.jpg"),
      // ],
          // [
          // require("../../assets/id/imgs/xianchang/1.jpg"),
          //     require("../../assets/id/imgs/xianchang/2.jpg"),
          //     require("../../assets/id/imgs/xianchang/3.jpg"),
          // ],
    ],
    // 封面
    fengurl: [
      // require("../../assets/id/imgs/xianchang/1-1.jpg"),
      // require("../../assets/id/imgs/xianchang/2-1.jpg"),
      require("../../assets/id/imgs/xianchang/4-1.jpg"),
      require("../../assets/id/imgs/xianchang/5-1.jpg"),
      require("../../assets/id/imgs/xianchang/6-1.jpg"),
      require("../../assets/id/imgs/xianchang/7-1.jpg"),
      require("../../assets/id/imgs/xianchang/8-1.jpg"),
      require("../../assets/id/imgs/xianchang/9-1.jpg"),
      require("../../assets/id/imgs/xianchang/10-1.jpg"),
      require("../../assets/id/imgs/xianchang/11-1.jpg"),
      require("../../assets/id/imgs/xianchang/12-1.jpg"),
      require("../../assets/id/imgs/xianchang/13-1.jpg"),
      require("../../assets/id/imgs/xianchang/14-1.jpg"),
      require("../../assets/id/imgs/xianchang/15-1.jpg"),
      require("../../assets/id/imgs/xianchang/16-1.jpg"),
      require("../../assets/id/imgs/xianchang/17-1.jpg"),
      require("../../assets/id/imgs/xianchang/18-1.jpg"),
      require("../../assets/id/imgs/xianchang/19-1.jpg"),
      require("../../assets/id/imgs/xianchang/20-1.jpg"),
      require("../../assets/id/imgs/xianchang/21-1.jpg"),
      require("../../assets/id/imgs/xianchang/3-1.jpg"),
    ]
  }
}
